import React from 'react';
import { Create, useTranslate } from 'react-admin';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import Form from './detail/Form';

const FormationCreate = (props) => {
  const translate = useTranslate();
  useDocumentTitle(
    translate('app.page_title.create', {
      resource: translate('resources.formation.name', { smart_count: 1 }),
    }),
  );
  return (
    <Create {...props}>
      <Form />
    </Create>
  );
};

export default FormationCreate;
